import ReduxHelper from 'lib/ReduxHelper';

export const BIDS_ACTION_TYPES = {
  BIDS_FETCH_DATA: 'BIDS_FETCH_DATA',
  BIDS_FETCH_DATA_SUCCESS: 'BIDS_FETCH_DATA_SUCCESS',
  BIDS_FETCH_DATA_FAIL: 'BIDS_FETCH_DATA_FAIL',
  BIDS_CLEAR_DATA: 'BIDS_CLEAR_DATA',

  BID_CANCEL: 'BID_CANCEL',
  BID_CANCEL_SUCCESS: 'BID_CANCEL_SUCCESS',
  BID_CANCEL_FAIL: 'BID_CANCEL_FAIL',

  BID_TEMP_SELECT: 'BID_TEMP_SELECT',
  BID_TEMP_SELECT_SUCCESS: 'BID_TEMP_SELECT_SUCCESS',
  BID_TEMP_SELECT_FAIL: 'BID_TEMP_SELECT_FAIL',
};

export const fetchBids = () =>
  ReduxHelper.createAction(BIDS_ACTION_TYPES.BIDS_FETCH_DATA);

export const cancelBid = bidId =>
  ReduxHelper.createAction(BIDS_ACTION_TYPES.BID_CANCEL, bidId);

export const selectTempBid = bidId =>
  ReduxHelper.createAction(BIDS_ACTION_TYPES.BID_TEMP_SELECT, bidId);
